import cashierSelectors from 'features/cashier/services/selectors';
import React from 'react';
import { Card, Row, Col as AntCol, Divider, Typography, Space } from 'antd';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { IBillDetailData } from 'features/payment/services/types/bill';
import { IPaymentInfoItem } from 'features/payment/services/types/api';
import { IGiftCardV3PaymentValue } from 'features/cashier/services/types/giftCard';
import Icon from 'assets/Icons';
import { sumBy } from 'lodash';
const Col = styled(AntCol)`
  flex: 1;
  display: flex;
  align-items: center;
`;
const Text = styled.div`
color: #1D2129;
font-family: Poppins;
font-size: 22px;
font-style: normal;
font-weight: 400;
line-height: normal;
&.text-table {
  color: #505050;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}
&.gift-card {
  color: #1D2129;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
`;
const StyledContainer = styled.div`
  width: 500px;
  background: #F5F5F5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  align-self: stretch;
  display: flex;
  padding-top: 16px;
  flex-direction: column;
`;

const RowSpace = styled(Row)`
  padding: 4px 16px;
`;

const BoldText = styled(Text)`
  color: #1D2129;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 125% */
  text-transform: capitalize;
  &.text-total {
    font-size: 32px;
    font-weight: 600;
  }
`;

const TotalSpace = styled(RowSpace)`
  background: #FFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding: 16px 16px;
`;

const HighlightBox = styled(TotalSpace)`
  background: #fde68a;
  padding: 12px 16px;
  text-align: right;
  margin-top: 16px;
`;
const TableRow = styled(Row)`
  padding: 0 16px;
`;

const GiftCardRecordList = styled.div`
    display:flex;
    flex-direction: column;
    flex: 1;
`;

type Props = {
  detail?: IBillDetailData | null;
  remaining?: number;
  giftCardPayments: IGiftCardV3PaymentValue[];
  onDeleteItem?: (o: IGiftCardV3PaymentValue) => void;
};
const GiftCardTicketInfo = ({ detail, remaining, giftCardPayments, onDeleteItem = () => undefined }: Props) => {
  return (
    <StyledContainer>
      <TotalSpace justify="space-between" style={{ background: 'transparent' }}>
        <BoldText>Subtotal</BoldText>
        <BoldText>{formatCurrency(detail?.subTotal)}</BoldText>
      </TotalSpace>
      <Divider style={{ margin: 0 }} />
      <RowSpace justify="space-between">
        <Text>Tip:</Text>
        <Text>{formatCurrency(detail?.tip)}</Text>
      </RowSpace>
      <RowSpace justify="space-between">
        <Text>Sale Tax:</Text>
        <Text>{formatCurrency(detail?.saleTax)}</Text>
      </RowSpace>
      <RowSpace justify="space-between">
        <Text>Used Tax:</Text>
        <Text>{formatCurrency(detail?.useTax)}</Text>
      </RowSpace>
      <RowSpace justify="space-between">
        <Text>Disc. By Item:</Text>
        <Text>{formatCurrency(detail?.discountItem)}</Text>
      </RowSpace>
      <RowSpace justify="space-between">
        <Text>Disc. By Ticket:</Text>
        <Text>{formatCurrency(detail?.discountTicket)}</Text>
      </RowSpace>
      <TotalSpace justify="space-between" style={{ margin: '16px 0' }}>
        <BoldText className='text-total'>Total</BoldText>
        <BoldText className='text-total'>{formatCurrency(detail?.total)}</BoldText>
      </TotalSpace>
      <GiftCardRecordList>
        <TableRow justify="space-between" style={{ marginBottom: 8 }}>
          <Col><Text className='text-table'>GIFT CODE</Text></Col>
          <Col style={{ justifyContent: 'flex-end' }}><Text className='text-table'>AMOUNT</Text></Col>
          <Col style={{ justifyContent: 'flex-end' }}><Text className='text-table'>REMAIN</Text></Col>
          <Col style={{ flex: 'unset' }}><Text className='text-table' style={{ width: 65, height: 1, opacity: 0 }}>123</Text></Col>
        </TableRow>
        {giftCardPayments.map(o => (
          <TableRow key={o.giftCardId} justify="space-between">
            <Col className='text-overflow'>
              <Text className='gift-card text-overflow'>
                {o.code}
              </Text>
            </Col>
            <Col style={{ justifyContent: 'flex-end' }}>
              <Text className='gift-card right'>
                {formatCurrency(o.amount)}
              </Text>
            </Col>
            <Col style={{ justifyContent: 'flex-end' }}>
              <Text className='gift-card right'>
                {formatCurrency(o.giftCardBalance)}
              </Text>
            </Col>
            <Col style={{ flex: 'unset' }}>
              <button style={{ width: 65, height: 45 }} type='button' onClick={() => onDeleteItem(o)}>
                <Icon type='deleteIconCashier' fill='#000' />
              </button>
            </Col>
          </TableRow>
        ))}
      </GiftCardRecordList>
      <HighlightBox style={{ height: 88 }}>
        <BoldText className='text-total'>Remaining</BoldText>
        <BoldText className='text-total'>{formatCurrency(remaining)}</BoldText>
      </HighlightBox>
    </StyledContainer>
  );
};

export default GiftCardTicketInfo;
